function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistorianKGroen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "black"
    },
    x: 4,
    y: 4,
    width: 120,
    height: 120,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "solid"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "black"
    },
    x: 4,
    y: 4,
    width: 120,
    height: 120,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 232, 134)",
      strokeWidth: 3,
      stroke: "black"
    },
    x: 4,
    y: 4,
    width: 120,
    height: 120,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5, 0, 0, 4.249999, -422.565033, -209.041199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90.313 74.245 L 104.313 74.245",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: "1.25924px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90.313 54.245 L 104.313 54.245",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: "1.25924px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102.313 74.245 L 102.313 70.073 C 102.313 69.542 102.102 69.033 101.727 68.659 L 97.313 64.245 L 92.899 68.659 C 92.524 69.033 92.313 69.542 92.313 70.073 L 92.313 74.245",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: "1.25924px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 92.313 54.245 L 92.313 58.417 C 92.313 58.947 92.524 59.456 92.899 59.831 L 97.313 64.245 L 101.727 59.831 C 102.102 59.456 102.313 58.947 102.313 58.417 L 102.313 54.245",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: "1.25924px"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorianKGroen);
export default __webpack_public_path__ + "static/media/historian-k-groen.799d87d2880d810a8f32b6de1e9af113.svg";
export { ForwardRef as ReactComponent };